export default __webpack_public_path__ + "static/media/landingpage-toptile.041b42be.png";